import { FunctionComponent } from "react";

import { ListPerson } from "../../../List/schema/list";
import { CreateHubspotDealModal } from "../../../Company/components/CreateHubspotDealModal";
import { CreateZohoDealModal } from "../../../Company/components/CreateZohoDealModal";
import { CreatePipedriveDealModal } from "../../../Company/components/CreatePipedriveDealModal";
import { CreateDynamicsDealModal } from "../../../Company/components/CreateDynamicsDealModal";
import { CreateSalesforceDealModal } from "../../../Company/components/CreateSalesforceDealModal";

interface InboxCrmDealModalsProps {
	listPerson: ListPerson;
	showHubspot: boolean;
	onCloseHubspot: () => void;
	showZoho: boolean;
	onCloseZoho: () => void;
	showPipedrive: boolean;
	onClosePipedrive: () => void;
	showDynamics: boolean;
	onCloseDynamics: () => void;
	showSalesforce: boolean;
	onCloseSalesforce: () => void;
}

/**
 * The five CRM "create deal" modals (HubSpot / Zoho / Pipedrive / Dynamics 365 / Salesforce)
 * opened from the Inbox action bar. They share the exact same prospect payload, so they live
 * together here to keep the Inbox page lean — each renders only when its `show*` flag is set.
 */
export const InboxCrmDealModals: FunctionComponent<InboxCrmDealModalsProps> = ({
	listPerson,
	showHubspot,
	onCloseHubspot,
	showZoho,
	onCloseZoho,
	showPipedrive,
	onClosePipedrive,
	showDynamics,
	onCloseDynamics,
	showSalesforce,
	onCloseSalesforce,
}) => {
	const prospect = listPerson.prospect;

	if (!prospect?.id) {
		return null;
	}

	const dealProps = {
		prospect: {
			firstName: prospect.firstName,
			lastName: prospect.lastName,
			email: prospect.email,
			title: prospect.title,
			organizationName: prospect.organization?.name,
		},
		prospectId: prospect.id,
	};

	return (
		<>
			{showHubspot && (
				<CreateHubspotDealModal isOpen={showHubspot} onClose={onCloseHubspot} {...dealProps} />
			)}
			{showZoho && <CreateZohoDealModal isOpen={showZoho} onClose={onCloseZoho} {...dealProps} />}
			{showPipedrive && (
				<CreatePipedriveDealModal
					isOpen={showPipedrive}
					onClose={onClosePipedrive}
					{...dealProps}
				/>
			)}
			{showDynamics && (
				<CreateDynamicsDealModal isOpen={showDynamics} onClose={onCloseDynamics} {...dealProps} />
			)}
			{showSalesforce && (
				<CreateSalesforceDealModal
					isOpen={showSalesforce}
					onClose={onCloseSalesforce}
					{...dealProps}
				/>
			)}
		</>
	);
};
